/* eslint-disable*/
import {
  Button,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Typography,
  withStyles,
  CircularProgress as MuiCircularProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styles from "./style";
import { useAlert } from "../../utility/customHooks";
import urls from "../../urls";
import OrchidsLogo from "../../assets/orchidsLogo.png";
import CRMLogo from "../../assets/CRMLogo.png";
import ErrorLogo from "../../assets/error.png";

const AdmissionEnquiry = ({ classes, history }) => {
  const [loading, setLoading] = useState(false);
  const [formObj, setFormObj] = useState({
    child_name: "",
    lead_name: "",
    country_code_primary: "+91",
    lead_contact_no: "",
    email: "",
    city: "",
    branch: "",
    grade: "",
  });

  const [searchParamsData, setSearchParamsData] = useState({
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    whatsapp_msg: true,
    medium_info: "",
    utm_term: "",
    gclid: "",
    utm_placement: "",
    utm_experiment: "",
    utm_network: "",
    utm_adgroup: "",
    utm_content: "",
    utm_extension: "",
    utm_position: "",
    lead_url: "",
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setSearchParamsData({
      utm_source: searchParams.has("utm_source")
        ? searchParams.get("utm_source")
        : "",
      utm_medium: searchParams.has("utm_medium")
        ? searchParams.get("utm_medium")
        : "",
      utm_campaign: searchParams.has("utm_campaign")
        ? searchParams.get("utm_campaign")
        : "",
      whatsapp_msg: searchParams.has("whatsapp_msg")
        ? searchParams.get("whatsapp_msg")
        : true,
      medium_info: searchParams.get("medium_info")
        ? searchParams.get("medium_info")
        : "",
      utm_term: searchParams.get("utm_term")
        ? searchParams.get("utm_term")
        : "",
      gclid: searchParams.get("gclid") ? searchParams.get("gclid") : "",
      utm_placement: searchParams.get("utm_placement")
        ? searchParams.get("utm_placement")
        : "",
      utm_experiment: searchParams.get("utm_experiment")
        ? searchParams.get("utm_experiment")
        : "",
      utm_network: searchParams.get("utm_network")
        ? searchParams.get("utm_network")
        : "",
      utm_adgroup: searchParams.get("utm_adgroup")
        ? searchParams.get("utm_adgroup")
        : "",
      utm_content: searchParams.get("utm_content")
        ? searchParams.get("utm_content")
        : "",
      utm_extension: searchParams.get("utm_extension")
        ? searchParams.get("utm_extension")
        : "",
      utm_position: searchParams.get("utm_position")
        ? searchParams.get("utm_position")
        : "",
      lead_url: searchParams.get("lead_url")
        ? searchParams.get("lead_url")
        : "",
    });
  }, [location.search]);

  const alert = useAlert();
  const [cityList, setCityList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const [schoolDetails, setSchoolDetails] = useState(null);
  const [currentAcademicYear, setCurrentAcademicYear] = useState(null);

  let subDomainName = "";
  if (window.location.hostname === "localhost") {
    subDomainName = "orchids";
  } else {
    if (
      window.location.hostname.includes("-marketing") ||
      window.location.hostname.includes("-stage")
    ) {
      subDomainName = window.location.hostname?.split(".")?.length
        ? window.location.hostname
            ?.split(".")[0]
            ?.replace("-marketing", "")
            ?.replace("-stage", "")
        : "orchids";
    } else {
      subDomainName = window.location.hostname?.split(".")?.length
        ? window.location.hostname?.split(".")[0]
        : "orchids";
    }
  }

  const getSchoolDetails = () => {
    fetch(`${urls.schoolLogoUrl}?school_sub_domain_name=${subDomainName}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-DTS-SCHEMA": urls.xdtsHost,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status_code === 200) {
          setSchoolDetails(data?.data);
        } else {
          setSchoolDetails({ error: true });
        }
      })
      .catch(() => {
        setSchoolDetails({ networkError: true });
      });
  };

  const getCurrentAcademicYear = () => {
    fetch(`${urls.academicYear}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-DTS-SCHEMA": urls.xdtsHost,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCurrentAcademicYear(
          data?.filter((item) => item?.default)?.length
            ? data?.filter((item) => item?.default)[0].session_year
            : "2024-25"
        );
      })
      .catch(() => {});
  };

  const getCities = () => {
    fetch(`${urls.cityList}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-DTS-SCHEMA": urls.xdtsHost,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCityList(data);
      })
      .catch(() => {
        alert.error("Failed To Complete Action");
      });
  };

  const getBranches = (id) => {
    fetch(`${urls.cityWiseBranches}?location=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-DTS-SCHEMA": urls.xdtsHost,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setBranchList(data);
      })
      .catch(() => {
        alert.error("Failed To Complete Action");
      });
  };

  const getGrade = (id) => {
    fetch(`${urls.branchWiseGrade}?branch=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-DTS-SCHEMA": urls.xdtsHost,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setGradeList(data);
      })
      .catch(() => {
        alert.error("Failed To Complete Action");
      });
  };

  useEffect(() => {
    getCities();
    getSchoolDetails();
    getCurrentAcademicYear();
  }, []);

  const countryCodeArray = [
    {
      value: "+91",
      maxRange: 10,
    },
    {
      value: "+243",
      maxRange: 10,
    },
    {
      value: "+966",
      maxRange: 10,
    },
    {
      value: "+353",
      maxRange: 10,
    },
    {
      value: "+230",
      maxRange: 10,
    },
    {
      value: "+1",
      maxRange: 10,
    },
    {
      value: "+968",
      maxRange: 8,
    },
    {
      value: "+7",
      maxRange: 10,
    },
    {
      value: "+65",
      maxRange: 8,
    },
    {
      value: "+971",
      maxRange: 13,
    },
    {
      value: "+44",
      maxRange: 11,
    },
    {
      value: "+84",
      maxRange: 11,
    },
    {
      value: "+49",
      maxRange: 10,
    },
    {
      value: "+60",
      maxRange: 10,
    },
    {
      value: "+81",
      maxRange: 10,
    },
    {
      value: "+61",
      maxRange: 10,
    },
    {
      value: "+965",
      maxRange: 10,
    },
    {
      value: "+974",
      maxRange: 10,
    },
  ];

  const getDisabled = () => {
    return (
      !formObj.child_name?.trim() ||
      !formObj.lead_name?.trim() ||
      !formObj.lead_contact_no ||
      !formObj.email?.trim() ||
      !formObj.city ||
      !formObj.branch ||
      !formObj.grade ||
      loading
    );
  };

  const handleSubmit = () => {
    if (
      formObj.lead_contact_no?.length !==
      countryCodeArray?.filter(
        (each) => each.value === formObj?.country_code_primary
      )[0]?.maxRange
    ) {
      alert.error(
        `Contact No. should be of ${
          countryCodeArray?.filter(
            (each) => each.value === formObj?.country_code_primary
          )[0]?.maxRange
        } digits`
      );
      return;
    }
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formObj?.email)) {
      alert.error("You have entered an Invalid email address!");
      return;
    }
    const obj = {
      whatsapp_msg: searchParamsData.whatsapp_msg,
      country_code_primary: formObj?.country_code_primary?.replace("+", ""),
      branch: formObj.branch,
      lead_name: formObj.lead_name,
      child_name: formObj.child_name,
      lead_email_id: formObj?.email,
      medium_info: searchParamsData.medium_info,
      utm_source: searchParamsData.utm_source,
      utm_medium: searchParamsData.utm_medium,
      utm_campaign: searchParamsData.utm_campaign,
      utm_term: searchParamsData.utm_term,
      gclid: searchParamsData.gclid,
      utm_placement: searchParamsData.utm_placement,
      utm_experiment: searchParamsData.utm_experiment,
      utm_network: searchParamsData.utm_network,
      utm_adgroup: searchParamsData.utm_adgroup,
      utm_content: searchParamsData.utm_content,
      utm_extension: searchParamsData.utm_extension,
      utm_position: searchParamsData.utm_position,
      lead_contact_no: formObj?.lead_contact_no,
      grade: formObj.grade,
      academic_year: currentAcademicYear,
      lead_url: searchParamsData.lead_url,
    };
    console.log(obj);
    setLoading(true);
    fetch(urls.websiteEnquiryForm, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-DTS-SCHEMA": urls.xdtsHost,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.message?.toLowerCase() === "success") {
          setFormObj({
            child_name: "",
            lead_name: "",
            country_code_primary: "+91",
            lead_contact_no: "",
            email: "",
            city: "",
            branch: "",
            grade: "",
          });
          setBranchList([]);
          setGradeList([]);
          history.replace("/thank-you-for-submit-enquiry");
        } else {
          alert.error(data.message);
        }
      })
      .catch(() => {
        setLoading(false);
        alert.error("Failed To Complete Action");
      });
  };

  return (
    <>
      {schoolDetails ? (
        schoolDetails.error || schoolDetails.networkError ? (
          <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ padding: 10 }}
          >
            <Grid item style={{ marginTop: 100 }}>
              <img
                src={ErrorLogo}
                alt="image1"
                style={{ height: 130, width: 130 }}
              />
            </Grid>
            <Grid item style={{ paddingTop: 30 }}>
              <Typography
                variant="h6"
                style={{
                  fontSize: 30,
                  fontWeight: "normal",
                  color: "red",
                  textAlign: "center",
                  lineHeight: 1.3,
                }}
              >
                {schoolDetails.error
                  ? "School Not Found. Please Try Again!"
                  : schoolDetails.networkError
                  ? "Something Went Wrong. Please Try Again!"
                  : ""}
              </Typography>
            </Grid>
            <Grid item style={{ paddingTop: 30 }}>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => {
                  getSchoolDetails();
                }}
              >
                Retry
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ height: "100vh" }}
          >
            <Grid item md={8} xs={11}>
              <Grid container alignItems="center" className={classes.paper}>
                <Grid item xs={12}>
                  <Grid container direction="column" alignItems="center">
                    <Grid item style={{ height: "125px" }}>
                      {schoolDetails ? (
                        <img
                          src={schoolDetails?.school_logo || CRMLogo}
                          alt="image1"
                          style={{
                            height: 120,
                            width: 120,
                          }}
                        />
                      ) : null}
                    </Grid>
                    <Grid item>
                      <Typography variant="h5">
                        {schoolDetails
                          ? schoolDetails?.school_name || "B2B School"
                          : null}
                      </Typography>
                    </Grid>

                    <Grid item style={{ marginTop: 10 }}>
                      <Typography variant="h6" style={{ color: "red" }}>
                        Admission Enquiry {currentAcademicYear}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="caption" style={{ fontSize: 10 }}>
                        A Journey To A Better Future Begins With Us
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Divider className={classes.divider} />
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        margin="dense"
                        fullWidth
                        variant="outlined"
                        inputProps={{ readOnly: loading }}
                        onChange={(e) => {
                          if (
                            (e.target.value &&
                              /^(?=.*[a-z])[a-z\s]+$/i.test(e.target.value)) ||
                            !e.target.value
                          ) {
                            setFormObj({
                              ...formObj,
                              child_name: e.target.value,
                            });
                          }
                        }}
                        label="Student Name"
                        value={formObj.child_name || ""}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        margin="dense"
                        fullWidth
                        variant="outlined"
                        inputProps={{ readOnly: loading }}
                        onChange={(e) => {
                          if (
                            (e.target.value &&
                              /^(?=.*[a-z])[a-z\s]+$/i.test(e.target.value)) ||
                            !e.target.value
                          ) {
                            setFormObj({
                              ...formObj,
                              lead_name: e.target.value,
                            });
                          }
                        }}
                        label="Parent Name"
                        value={formObj.lead_name || ""}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid container spacing={1}>
                        <Grid item xs={4} md={3}>
                          <TextField
                            label="Code"
                            margin="dense"
                            onChange={(e) => {
                              setFormObj({
                                ...formObj,
                                country_code_primary: e.target.value,
                                lead_contact_no: "",
                              });
                            }}
                            inputProps={{ readOnly: loading }}
                            variant="outlined"
                            required
                            fullWidth
                            select
                            value={formObj.country_code_primary}
                          >
                            {countryCodeArray &&
                              countryCodeArray.map((data) => (
                                <MenuItem
                                  value={data.value}
                                  key={data.value}
                                  name={data.value}
                                >
                                  {data.value}
                                </MenuItem>
                              ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={8} md={9}>
                          <TextField
                            type="number"
                            margin="dense"
                            fullWidth
                            className={classes.numberTextField}
                            variant="outlined"
                            inputProps={{ readOnly: loading }}
                            onChange={(e) => {
                              if (
                                e.target.value.length <=
                                countryCodeArray?.filter(
                                  (each) =>
                                    each.value === formObj?.country_code_primary
                                )[0]?.maxRange
                              )
                                setFormObj({
                                  ...formObj,
                                  lead_contact_no: e.target.value,
                                });
                            }}
                            onKeyDown={(e) => {
                              ["e", "E", "+", "-", "."].includes(e.key) &&
                                e.preventDefault();
                            }}
                            label="Contact No"
                            value={formObj.lead_contact_no || ""}
                            required
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Email"
                        margin="dense"
                        required
                        fullWidth
                        value={formObj.email}
                        inputProps={{ readOnly: loading }}
                        onChange={(e) => {
                          setFormObj({
                            ...formObj,
                            email: e.target.value,
                          });
                        }}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="City"
                        margin="dense"
                        onChange={(e) => {
                          setFormObj({
                            ...formObj,
                            city: e.target.value,
                            branch: "",
                            grade: "",
                          });
                          getBranches(e.target.value);
                          setBranchList([]);
                        }}
                        inputProps={{ readOnly: loading }}
                        variant="outlined"
                        required
                        fullWidth
                        select
                        value={formObj.city}
                      >
                        {cityList &&
                          cityList.map((data) => (
                            <MenuItem
                              value={data.id}
                              key={data.id}
                              name={data.city_name}
                            >
                              {data.city_name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Branch"
                        margin="dense"
                        onChange={(e) => {
                          setFormObj({
                            ...formObj,
                            branch: e.target.value,
                            grade: "",
                          });
                          getGrade(e.target.value);
                          setGradeList([]);
                        }}
                        inputProps={{ readOnly: loading }}
                        variant="outlined"
                        required
                        fullWidth
                        select
                        value={formObj.branch}
                      >
                        {branchList &&
                          branchList.map((data) => (
                            <MenuItem
                              value={data.id}
                              key={data.id}
                              name={data.branch_name}
                            >
                              {data.branch_name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Grade"
                        margin="dense"
                        onChange={(e) => {
                          setFormObj({
                            ...formObj,
                            grade: e.target.value,
                          });
                        }}
                        inputProps={{ readOnly: loading }}
                        variant="outlined"
                        required
                        fullWidth
                        select
                        value={formObj.grade}
                      >
                        {gradeList &&
                          gradeList.map((data) => (
                            <MenuItem
                              value={data.id}
                              key={data.id}
                              name={data.grade}
                            >
                              {data.grade}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center", marginTop: 10 }}
                >
                  <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    disabled={getDisabled()}
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {loading ? (
                      <MuiCircularProgress
                        size={20}
                        color="white"
                        style={{ marginRight: 10 }}
                      />
                    ) : null}
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )
      ) : null}
    </>
  );
};

export default withStyles(styles)(AdmissionEnquiry);
